import React, { useState } from "react";
import {
  Row,
  Col,
  Tag,
  Typography,
  Divider,
  Empty,
  Space,
  Avatar,
  Button,
} from "antd";
import {
  TeamOutlined,
  IdcardOutlined,
  HomeOutlined,
  PhoneOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import THEME from "../theme";
import { formatDate } from "../utils";
import StyledCard from "../components/StyledCard";
import EditCustomerContactModal from "../components/EditCustomerContactModal";

const { Text } = Typography;

const GuarantorsTab = ({ loanData, loadLoanData, userId }) => {
  const guarantors = loanData?.GUARANTORS || [];
  const dataType = loanData?.LOAN?.DATA_TYPE;
  const contno = loanData?.LOAN?.CONTNO;

  const [editModal, setEditModal] = useState({
    open: false,
    mode: "phone",
    guarantor: null,
    address: null,
  });

  const openEditPhone = (guarantor) =>
    setEditModal({ open: true, mode: "phone", guarantor, address: null });
  const openEditAddress = (guarantor, address) =>
    setEditModal({ open: true, mode: "address", guarantor, address });
  const closeEditModal = () =>
    setEditModal((prev) => ({ ...prev, open: false }));
  const handleEditSuccess = () => {
    if (contno) loadLoanData?.(contno);
  };

  if (guarantors?.length === 0) return;
  return (
    <StyledCard
      title={`ผู้ค้ำประกัน (${guarantors?.length} คน)`}
      icon={<TeamOutlined style={{ color: THEME.primary, fontSize: 18 }} />}
    >
      {guarantors?.length === 0 ? (
        <Empty description="ไม่มีข้อมูลผู้ค้ำประกัน" />
      ) : (
        <Row gutter={[16, 16]}>
          {guarantors?.map((g, idx) => {
            return (
              <Col xs={24} lg={12} key={idx}>
                <div
                  style={{
                    padding: 20,
                    background: THEME.light,
                    borderRadius: 10,
                    borderLeft: `4px solid ${THEME.accent}`,
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      marginBottom: 16,
                    }}
                  >
                    <Avatar size={56} style={{ background: THEME.accent }}>
                      {g.NAME1?.charAt(0)}
                    </Avatar>
                    <div style={{ flex: 1 }}>
                      <Text strong style={{ fontSize: 18 }}>
                        {g.SNAM}
                        {g.NAME1} {g.NAME2}
                      </Text>
                      <br />
                      <Space size={4}>
                        <Tag color="orange">คนค้ำที่ {g.GARNO}</Tag>
                        <Tag>{g.RELATN}</Tag>
                      </Space>
                    </div>
                    <Button
                      icon={<EditOutlined />}
                      size="small"
                      disabled={userId !== 1 && userId !== 4}
                      onClick={() => openEditPhone(g)}
                    >
                      แก้ไขเบอร์โทรศัพท์
                    </Button>
                  </div>
                  <Row gutter={[12, 8]}>
                    <Col span={24}>
                      <Text type="secondary" style={{ fontSize: 16 }}>
                        <IdcardOutlined style={{ marginRight: 6 }} />
                        เลขบัตรประชาชน
                      </Text>
                      <br />
                      <Text copyable strong>
                        {g.CUSCOD}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <Text type="secondary" style={{ fontSize: 16 }}>
                        วันเกิด
                      </Text>
                      <br />
                      <Text style={{ fontSize: 18 }}>
                        {formatDate(g.BIRTHDT)}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <Text type="secondary" style={{ fontSize: 16 }}>
                        อาชีพ
                      </Text>
                      <br />
                      <Text style={{ fontSize: 18 }}>{g?.OCCUP || "-"}</Text>
                    </Col>
                    <Col span={12}>
                      <Text type="secondary" style={{ fontSize: 16 }}>
                        ที่ทำงาน
                      </Text>
                      <br />
                      <Text style={{ fontSize: 16 }} copyable>
                        {g.OFFIC || "-"}
                      </Text>
                    </Col>
                    <Col span={12}>
                      <Text type="secondary" style={{ fontSize: 16 }}>
                        <PhoneOutlined style={{ marginRight: 6 }} />
                        เบอร์ส่วนตัว
                      </Text>
                      <br />
                      <Text copyable strong style={{ fontSize: 16 }}>
                        {g?.MOBILENO || "-"}
                      </Text>
                    </Col>
                  </Row>
                  <Divider style={{ margin: "12px 0" }} />
                  <div
                    style={{
                      padding: 12,
                      background: "#fff",
                      borderRadius: 8,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: 8,
                      }}
                    >
                      <Button
                        icon={<PlusOutlined />}
                        size="small"
                        disabled={userId !== 1 && userId !== 4}
                        onClick={() => openEditAddress(g, null)}
                      >
                        เพิ่มที่อยู่
                      </Button>
                    </div>
                    {(g.ADDRESS || []).map((addr, addrIdx) => (
                      <React.Fragment key={addr.ADDRNO || addrIdx}>
                        {addrIdx > 0 && <Divider style={{ margin: "8px 0" }} />}
                        <Space align="center">
                          <Text type="secondary" style={{ fontSize: 16 }}>
                            <HomeOutlined style={{ marginRight: 6 }} />
                            ที่อยู่ {addr.ADDRNO}
                          </Text>
                          {g.MAIN_ADDRNO === addr.ADDRNO && (
                            <Tag color="blue">ที่อยู่หลัก</Tag>
                          )}
                          <Button
                            icon={<EditOutlined />}
                            size="small"
                            type="text"
                            // disabled={userId !== 1 && userId !== 4}
                            disabled
                            onClick={() => openEditAddress(g, addr)}
                          />
                        </Space>
                        <br />
                        <Text style={{ fontSize: 16 }} copyable>
                          {`${addr.ADDR1} ${addr.ADDR2} ตำบล. ${addr.TUMB} อำเภอ. ${addr.AUMPDES} จังหวัด. ${addr.PROVDES} รหัสไปรษณีย์.${addr.ZIP}`.trim()}
                        </Text>
                        <br />
                        <Space style={{ marginTop: 8 }}>
                          <PhoneOutlined style={{ color: THEME.success }} />
                          <Text strong copyable>
                            {addr.TELP || "-"}
                          </Text>
                        </Space>
                      </React.Fragment>
                    ))}
                    {(!g.ADDRESS || g.ADDRESS.length === 0) && <Text>-</Text>}
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      )}
      <EditCustomerContactModal
        open={editModal.open}
        onClose={closeEditModal}
        mode={editModal.mode}
        customer={editModal.guarantor}
        dataType={dataType}
        addresses={editModal.guarantor?.ADDRESS || []}
        editingAddress={editModal.address}
        onSuccess={handleEditSuccess}
      />
    </StyledCard>
  );
};

export default GuarantorsTab;
